@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText"></ms-market-help>
}
<div
    class="bet-builder-over-under-container option-group-container double"
    [style.--option-group-rows]="visibleRows()"
    [ngClass]="{ 'ht-of-single-row-options': !showMoreLessButtonVisible && isSingleRowOfOptions() }">
    <ng-container *rxFor="let group of visibleOptionGroups$; trackBy: trackGroup">
        <ms-bet-builder-option
            *ngFor="let option of group.options; trackBy: trackOption"
            [option]="option"
            [tracking]="{ source: tracking }"
            [optionGroup]="optionGroup"
            [event]="event"
            [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
            [sourceOfPick]="sourceOfPick"></ms-bet-builder-option>
    </ng-container>
</div>
@if (showMoreLessButtonVisible) {
    <div class="show-more-less-button" [ngClass]="{ expanded: expanded }" (click)="onShowMoreLessButtonToggle()">
        {{ expanded ? sitecore.event.ShowLess : sitecore.event.ShowMore }} <vn-icon name="theme-right" size="12" class="right-icon" />
    </div>
}
